module.exports = __webpack_public_path__ + "img/why-use-oc-image-03.1ae9098.svg";